/**
 * DataTablesのメッセージ管理を行う.
 *
 * @author Nakagawa_Michio@ogis-ri.co.jp
 *
 */
const EN = require('./datatables_messages_en.json')
const JA = require('./datatables_messages_ja.json')
const ZH = require('./datatables_messages_zh.json')

switch ($('html').attr('lang')) {
  case 'ja':
    $.extend($.fn.dataTable.defaults, {
      language: JA,
    })
    break
  case 'zh':
    $.extend($.fn.dataTable.defaults, {
      language: ZH,
    })
    break
  default:
    $.extend($.fn.dataTable.defaults, {
      language: EN,
    })
}
